const BASE_URL = "https://christophercook.me.uk:8080/api/v1/";
const IMAGE_REF = "/images/";

export {BASE_URL, IMAGE_REF};
